import React,{ useState } from 'react'
import {
    Box,
    IconButton,
    Stack
  } from "@chakra-ui/react";

import { AiOutlineFileSearch } from "react-icons/ai";

import LabledDatePicker from "../common/LabeledDatePicker";


function DateRangeSelector(props) {
    const [startDate, setStartDate] = useState(props.startDate);
    const [endDate, setEndDate] = useState(props.endDate);
    const [validationErrors, setValidationErrors] = useState({ startDate: null,endDate: null });
    
    const handleSubmit = ()=>{
        if (!startDate || !endDate) {
            let error = {};
            if (!startDate) 
              error["startDate"] = "Start date required...!";
            if (!endDate) 
              error["endDate"] = "End date required...!";
            setValidationErrors({ ...validationErrors, ...error });
            return;
          }
          if (startDate > endDate) {
            setEndDate(null);
            setValidationErrors({ ...validationErrors,endDate:"End date required...!"});
            // setValidationErrors({...validationErrors,'endDate':"Please select the date greater than or equal start date"});
            return;
          }
        if(props.hasOwnProperty('handleSubmit'))
            props.handleSubmit(startDate, endDate);
    }

    return (
        <Stack direction="row" p={2} pr={4}>
        <Box>
          <LabledDatePicker
            validationClass={
              validationErrors.startDate ? "inputValidationError" : ""
            }
            label="Start date"
            selected={startDate}
            onChange={(date) => {
              if (startDate > endDate){
                setEndDate(null);
              }
              if(validationErrors.startDate){
                setValidationErrors({
                  ...validationErrors,
                  startDate: null,
                });
              }
              setStartDate(date)
            }}
          />
        </Box>
        <Box >
          <LabledDatePicker
            validationClass={
              validationErrors.endDate ? "inputValidationError" : ""
            }
            label="End date"
            selected={endDate}
            minDate={startDate}
            onChange={(date) => {
              if(validationErrors.endDate){
                setValidationErrors({
                  ...validationErrors,
                  endDate: null,
                });
              }
              setEndDate(date);
            }}
          />
        </Box>
        <Box >
          <IconButton
            size="md"
            aria-label="Search"
            onClick={handleSubmit}
            borderWidth={'1px'} 
            borderColor={'rgb(94,94,114,.3)'} 
            icon={<AiOutlineFileSearch />}
          />
        </Box>
      </Stack>
    )
}

export default DateRangeSelector
